var map = {
	"./black/bofangluyin2.png": "EuwL",
	"./blue/bofangluyin2.png": "KUlc",
	"./white/bofangluyin2.png": "e60w"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "mQFs";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/bofangluyin2\.png$
// module id = mQFs
// module chunks = 24